/**
 * @param {import("@seabrookstudios/pitch2table-core").InboxMatchReason} reason
 * @returns {string|undefined}
 */
export const plainInboxMatchReason = (reason) => {
  if (reason === "singleOpenSubmission") {
    return "Matches the publisher's email domain";
  }
  if (reason === "subjectAndDomain") {
    return "Matches the game name in the subject";
  }
  if (reason === "publisherContact") {
    return "Matches a known publisher contact";
  }
  if (reason === "thread") {
    return "Matches this email thread";
  }
  return undefined;
};

/**
 * @param {import("@seabrookstudios/pitch2table-core").InboxMatchReason[]|null|undefined} reasons
 * @returns {string|undefined}
 */
export const plainInboxMatchHint = (reasons) => {
  if (!reasons?.length) {
    return undefined;
  }

  const phrases = [
    ...new Set(
      reasons
        .map((reason) => {
          return plainInboxMatchReason(reason);
        })
        .filter(Boolean)
    ),
  ];

  if (!phrases.length) {
    return undefined;
  }

  return phrases.join(", ");
};
